<template>
    <div class="announcement-sender-container container">
      <el-card shadow="hover">
        <template #header>
          <div class="card-header">
            <h2>إرسال إعلان عام</h2>
          </div>
        </template>
  
        <el-alert
          title="إرسال إشعار لجميع المستخدمين"
          type="warning"
          description="سيتم إرسال هذا الإعلان كإشعار فوري (Push Notification) إلى جميع مستخدمي التطبيق الذين قاموا بتسجيل الدخول. الرجاء التأكد من محتوى الإعلان قبل الإرسال."
          :closable="false"
          show-icon
          style="margin-bottom: 20px;"
        />
  
        <el-form :model="form" ref="formRef" label-position="top" :rules="rules">
          <el-form-item label="عنوان الإعلان" prop="title">
            <el-input v-model="form.title" placeholder="مثال: عطلة رسمية" />
          </el-form-item>
          <el-form-item label="محتوى الإعلان" prop="body">
            <el-input v-model="form.body" type="textarea" :rows="4" placeholder="تفاصيل الإعلان..." />
          </el-form-item>
          <el-form-item label="صورة الإعلان (اختياري)">
            <el-upload
              class="image-uploader"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleImageChange"
            >
              <img v-if="imagePreview" :src="imagePreview" class="image-preview" />
              <el-icon v-else class="image-uploader-icon"><Plus /></el-icon>
            </el-upload>
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-top: 20px;">
          <el-button type="primary" @click="sendAnnouncement" :loading="isLoading" size="large">
            <el-icon><Promotion /></el-icon> إرسال الإعلان الآن
          </el-button>
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus';
  import { Plus, Promotion } from '@element-plus/icons-vue';
  
  export default {
    name: 'AnnouncementSender',
    components: { Plus, Promotion },
    data() {
      return {
        api: null,
        isLoading: false,
        form: {
          title: '',
          body: '',
          image: null,
        },
        imagePreview: null,
        rules: {
          title: [{ required: true, message: 'عنوان الإعلان مطلوب', trigger: 'blur' }],
          body: [{ required: true, message: 'محتوى الإعلان مطلوب', trigger: 'blur' }],
        },
      };
    },
    created() {
      this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
      this.api.interceptors.request.use((config) => {
        const token = localStorage.getItem('access_token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
      });
    },
    methods: {
      handleImageChange(file) {
        const isImage = file.raw.type.startsWith('image/');
        if (!isImage) {
          ElMessage.error('الرجاء اختيار ملف صورة صالح.');
          return;
        }
        this.form.image = file.raw;
        this.imagePreview = URL.createObjectURL(file.raw);
      },
      async sendAnnouncement() {
        if (!this.$refs.formRef) return;
        await this.$refs.formRef.validate(async (valid) => {
          if (!valid) return;
          this.isLoading = true;
  
          const formData = new FormData();
          formData.append('title', this.form.title);
          formData.append('body', this.form.body);
          if (this.form.image) {
            formData.append('image', this.form.image);
          }
  
          try {
            const response = await this.api.post('/announcements/send', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            });
            ElMessage.success(response.data.message);
            this.$refs.formRef.resetFields();
            this.imagePreview = null;
            this.form.image = null;
          } catch (error) {
            ElMessage.error(error.response?.data?.message || 'فشلت عملية الإرسال.');
          } finally {
            this.isLoading = false;
          }
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .announcement-sender-container { padding: 20px; }
  .card-header { display: flex; justify-content: space-between; align-items: center; }
  .image-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .image-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
    line-height: 178px;
  }
  .image-preview {
    width: 178px;
    height: 178px;
    object-fit: cover;
  }
  </style>
  